import { createRouter, createWebHistory, RouterView } from "vue-router";
import { LayoutPage } from "@app/vue/pages/index";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    component: LayoutPage,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
